import React from "react";
import { UiComponents } from "@simulanisindia/ui";
import { BackArrowIcon, FilterIcon, Groups } from "../../Assets/Icons";
import { useNavigate } from "react-router-dom";
import FilterManagement from "../../components/FilterManagement";

const { BackButton, SearchBar, NormalGradientButton } = UiComponents;


const OrganizationHeader = ({ search, setSearch, orgLength }) => {

    const navigate = useNavigate();
    const backClick = () => navigate(-1);

    return (
        <>
            <div className="page-title with-functions">
                <div className="title-back">
                    <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
                    <h6>Organization Management </h6>
                </div>
             {orgLength > 0 && <div className="functions">
                    <SearchBar
                        onClick={() => { }}
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    {/* <FilterManagement /> */}
                    <NormalGradientButton onClick={() => navigate('/organization/create')} icon={<Groups />} text="Create Organization" />
                </div>}
            </div>
        </>
    )
}

export default OrganizationHeader;